import Moment from 'moment';
import ajaxRequestV2 from "core/gd/api-request/lib/ajax-request-v2";


// DEPRECATED but new class is missing ....


module.exports = function (context, type, endpoint, data, processSessionResponse=true, autoError=true) {

    //var transport = 'ajax';

    if (endpoint.substring(0,1)==='/') endpoint.substr(1);

    const apiUrl       =  gdConfig.apiUrl

    // add utcOffset
    if (!data) data={};
    data.zz = Moment().format("ZZ");
    data.sid = gd.sessionId;
    data.cid = gd.companyId;    // cid = CompanyID - it can be empty but usually not


    const headers = {};
    if (gd.auth && gd.auth.authMode === 'token') {
        headers['SessionMode'] = 'token';
        headers['SessionToken'] = gd.auth.authToken;
    }

    headers['gd-cid'] = gd.companyId // add cid (companyId) to header -> from now header is the best way to add to request

    return ajaxRequestV2({
        'type'          : type,
        'endpoint'      : endpoint,
        'url'           : apiUrl + endpoint,
        'payload'       : data,
        'context'       : context,
        'headers'       : headers
    }, {
        "autoError"                 : autoError,
        "processSessionResponse"    : processSessionResponse
    })

};
